import React from 'react';
import { Box } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from './HeroCarousel.module.css';

// S3 bucket base URL from environment variables
const S3_BUCKET_URL = process.env.REACT_APP_S3_BUCKET_URL || 'https://myeventshop-images.s3.amazonaws.com';

type Event = {
    id: number;
    title: string;
    image: string;
    venue: string;
    date: string;
    time: string;
};

type Props = {
    events: Event[];
};

const HeroCarousel: React.FC<Props> = ({ events }) => {
    // Function to process image URLs
    const getImageUrl = (imagePath: string): string => {
        if (imagePath.startsWith('http')) {
            return imagePath; // Already a full URL
        }
        return `${S3_BUCKET_URL}/${imagePath}`; // Add S3 bucket URL prefix
    };

    return (
        <Box
            sx={{
                width: '100%',
                height: { xs: '300px', md: '550px' },  // Responsive height
                overflow: 'hidden',
                position: 'relative',
            }}
        >
            <Swiper
                spaceBetween={0}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                pagination={{ clickable: true }}
                modules={[Autoplay, Pagination]}
                style={{ width: '100%', height: '100%' }}
            >
                {events.map((event) => (
                    <SwiperSlide key={event.id}>
                        <Box
                            sx={{
                                backgroundImage: `url(${getImageUrl(event.image)})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                height: '100%',
                                width: '100%',
                            }}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    );
};

export default HeroCarousel;
